<template>
  <v-layout class="container-modal">
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" max-width="800px" transition="dialog-bottom-transition">
      <v-card style="background-color: #f5f5f5;">
          <v-card-title class="p-3 header-modal mb-4">
            <span class="headline text-white">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text class="pb-0">
            <v-row class="align-center justify-center mb-4">
              <v-col md="11" class="elevation-0 pt-4 pb-4 mt-4" style="background: #f5f5f5">
                <v-stepper v-model="step" :items="steps" hide-actions :height="350">
                  <template v-slot:[`item.${1}`]>
                    <v-row class="justify-center align-center">
                      <v-col md="12" class="d-flex align-center justify-center">
                        <div class="align-center">
                          <!-- <div class="mt-2 mb-2">
                            <v-label class="text-order-pay">Ingresar dinero a billetera</v-label>
                          </div> -->
                          <div class="mt-2 mb-4">
                            <v-label>Ingrese monto*</v-label>
                            <v-text-field 
                              v-model="item.amount" 
                              :disabled="disabled" 
                              density="compact" 
                              :rules="[rules.required, rules.minAmount]" 
                              persistent-hint 
                              variant="outlined"
                              prefix="$"
                              type="text"
                              min="1"
                              step="0.01"
                              class="mt-2"
                            ></v-text-field>
                          </div>
                      
                          <div class="mt-2">
                            <v-label class="subtext-order-pay">Se agregará dinero a tu billetera virtual para poder realizar pagos de ordenes.</v-label>
                          </div>

                          <div class="text-center justify-center align-center mt-4">
                            <Button 
                              flat 
                              :loading="loading" 
                              text 
                              class="bg-button-register btn text-capitalize  text-white btn-modal" 
                              rounded="xl" 
                              height="50" 
                              label="Pagar" 
                              @click="handleDeposit"
                              :disabled="!item.amount || parseFloat(item.amount) <= 0"
                            ></Button>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:[`item.${2}`]>
                    <StatusMessage 
                      :status="paymentStatus" 
                      :title="statusTitle" 
                      :message="statusMessage" 
                      @handlePay="handleDeposit" 
                      :loading="loading" 
                    />
                  </template>
                </v-stepper>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="justify-end pt-0">
            <Button 
              flat 
              class="btn text-capitalize text-white me-1 btn-modal" 
              type="button" 
              rounded="xl" 
              height="50" 
              text 
              @click="closeModal()" 
              label="Cerrar" 
              color="error"
            ></Button>
          </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import StatusMessage from "../Orders/StatusMessage.vue";
import ValidMixin from "@/mixins/ValidMixin.vue";
import Button from "@/components/Button.vue";
import { mpService } from "@/libs/ws/MercadoPago/mpService";

export default {
  mixins: [ValidMixin],
  components: { StatusMessage, Button },
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    dialog: Boolean,
    updateDialog: Function,
    statusTitle: String,
    statusMessage: String,
    paymentStatus: String,
    step_pay: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      show: false,
      disabled: false,
      loading: false,
      name: "",
      step: this.step_pay,
      item: {
        amount: null,
      },
      steps: [
        {
          title: "Ingresar monto",
          content: "First-content",
          value: 1,
        },
        {
          title: "Detalle",
          content: "Second-content",
          value: 2,
        },
      ],
      defaultItem: null,
    };
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = false;
        this.step = this.step_pay; // Usar el step que viene desde las props

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.defaultItem != null) {
          this.item = JSON.parse(JSON.stringify(this.defaultItem));
        }
      }
    },
    step_pay(newVal) {
      // Actualizar el step cuando cambie desde el padre
      this.step = newVal;
    },
  },
  computed: {
    formBtn() {
      return 'Ingresar Dinero';
    }
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
    
  },
  methods: {
    closeModal() {
      this.$emit("updateDialog", false);
      this.step = 1; // Resetear al step 1 cuando se cierre
    },
    

    async handleDeposit() {

      this.loading = true;

      const body = {
        amount: parseFloat(this.item.amount),
      };

      console.log("body", body)
      try {
        const response = await mpService.createPreference(body);
        
        if (response.status) {
          // Redirigir a MercadoPago
          window.location.href = response.result.preference_link;
        } else {
          if (Object.prototype.hasOwnProperty.call(response, "message")) {
            this.toast.error(response.message);
          } else {
            this.toast.error(response.msg);
          }
        }
      } catch (error) {
        console.error('Error al crear preferencia de depósito:', error);
        this.toast.error(error.msg || 'Error al procesar el depósito');
      } finally {
        this.loading = false;
      }
    },

    // Método que se llamaba antes, ahora redirige a handleDeposit
    async depositCreated() {
      this.$emit('depositCreated');
    },
  },
};
</script>
